let renderRoot: Element;
export function getRenderRoot(): Element {
    if (!renderRoot) {
        // We provide a new div if the root is not present, which is the case during testing
        renderRoot =
            document.getElementById('root') || document.createElement('div');
    }
    return renderRoot;
}
